(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74],{

/***/ 61622:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/import",
      function () {
        return __webpack_require__(87440);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(57389);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(59072);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(9970);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84902);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78174);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59496);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(21849);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(95017);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(74098);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(92750);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(55570);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(26482);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(49634);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(64741);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(22112);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(20629);
/* harmony import */ var _material_ui_icons_InfoOutlined__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(82730);
/* harmony import */ var _material_ui_icons_MenuBookSharp__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(24729);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95682);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56530);
/* harmony import */ var _utils_authLib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61852);
/* harmony import */ var _utils_axiosApi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86156);
/* harmony import */ var _utils_errorLib__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27497);
/* harmony import */ var _utils_materialsLib__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46116);
/* harmony import */ var _components_AppState__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66791);
/* harmony import */ var _utils_users__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19399);
/* harmony import */ var _components_Accordions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56475);
/* harmony import */ var _components_GalleryTabSelector__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92957);
/* harmony import */ var _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88570);
/* harmony import */ var _components_ProgressButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78520);
/* harmony import */ var _components_TagList__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(28132);
/* harmony import */ var _utils_shared_business__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(54834);
/* harmony import */ var _utils_shared_formatLib__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71028);
/* harmony import */ var _utils_shared_metadataLib__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81283);
/* harmony import */ var _utils_linksLib__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(89047);
/* harmony import */ var _utils_useAuth__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(74216);


































var tagsHelpText = "Tagging your materials can be useful for filtering and finding materials in your library";
var scanType = _utils_shared_metadataLib__WEBPACK_IMPORTED_MODULE_19__/* .ScanType.TEXTURE_IMPORT */ .pv.TEXTURE_IMPORT;
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function(theme) {
    return {
        form: {
            "& .MuiTextField-root": {
                margin: theme.spacing(1)
            }
        },
        tagsContainer: {
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(2.5)
        },
        tagsText: {
            minWidth: "40px"
        },
        tags: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        guideButton: {
            marginTop: theme.spacing(-1),
            marginLeft: theme.spacing(2.5)
        },
        guideIcon: {
            marginRight: theme.spacing(0.5)
        },
        helpIcon: {
            marginLeft: theme.spacing(0.5),
            opacity: 0.5
        },
        discountText: {
            color: theme.palette.primary.main,
            fontSize: "0.95em"
        },
        discountIcon: {
            color: theme.palette.primary.main,
            fontSize: "2em",
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(0.25)
        },
        accordion: {
            marginTop: theme.spacing(1),
            marginLeft: "0.5em"
        },
        checkboxContainer: {
            display: "flex",
            alignItems: "center",
            marginLeft: theme.spacing(1)
        }
    };
});
function Import(props) {
    var updateAdvancedProcessing = function updateAdvancedProcessing(event, expanded) {
        setAdvancedProcessingExpanded(expanded);
    };
    var updateImportFilenames = function updateImportFilenames(filename, mapType) {
        setImportFilenames(function(param) {
            var items = param.items;
            return {
                items: items.set(filename, mapType)
            };
        });
    };
    var validateForm = function validateForm() {
        return uploadComplete && !loading && materialId && (uploadMethod !== _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY || importFilenames.items.size > 0 && mapTypeErrors.length === 0 && originalPhotos.every(function(op) {
            return Boolean(importFilenames.items.get(op.name));
        }));
    };
    var tagNamesFromList = function tagNamesFromList(tagList) {
        var tagNames = [];
        if (tagList) {
            tagList.forEach(function(t) {
                tagNames.push(t.label);
            });
        }
        return tagNames;
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_components_AppState__WEBPACK_IMPORTED_MODULE_10__/* .AppContext */ .I), galleryUser = ref.galleryUser, showAlert = ref.showAlert, setNavWarning = ref.setNavWarning, userTags = ref.userTags, qaDisplay = ref.qaDisplay, importAvailable = ref.importAvailable;
    var apiPost = (0,_utils_axiosApi__WEBPACK_IMPORTED_MODULE_7__/* .useAxios */ .b)().apiPost;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), tagList = ref1[0], setTagList = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), name = ref2[0], setName = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), text = ref3[0], setText = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), sku = ref4[0], setSku = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), photos = ref5[0], setPhotos = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), originalPhotos = ref6[0], setOriginalPhotos = ref6[1];
    // We use a Map inside an object to trigger a re-render when the Map is updated
    // https://stackoverflow.com/a/78188977/22374074
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        items: new Map()
    }), importFilenames = ref7[0], setImportFilenames = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), uploadComplete = ref8[0], setUploadComplete = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), loading = ref9[0], setLoading = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), processSuccess = ref10[0], setProcessSuccess = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), processFail = ref11[0], setProcessFail = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), redirect = ref12[0], setRedirect = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), materialId = ref13[0], setMaterialId = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(_components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY), uploadMethod = ref14[0], setUploadMethod = ref14[1];
    var _obj;
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_obj, _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY, ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_obj, _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.WE_TRANSFER */ .gc.WE_TRANSFER, ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_obj, _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.S3 */ .gc.S3, "s3://"), _obj)), uploadLinks = ref15[0], setUploadLinks = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), skipTiling = ref16[0], setSkipTiling = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), advancedProcessingExpanded = ref17[0], setAdvancedProcessingExpanded = ref17[1];
    var isAuthenticated = (0,_utils_useAuth__WEBPACK_IMPORTED_MODULE_20__/* .useAuth */ .a)().isAuthenticated;
    var ref18 = (0,_utils_users__WEBPACK_IMPORTED_MODULE_11__/* .useUser */ .A6)(galleryUser), galleryUserItem = ref18.userItem;
    var classes = useStyles();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        mixpanel_browser__WEBPACK_IMPORTED_MODULE_5__/* ["default"].track */ .Z.track("View Import");
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var disallowImport = importAvailable === false && !qaDisplay;
        if (disallowImport) {
            window.open(_utils_shared_business__WEBPACK_IMPORTED_MODULE_17__/* .importLandingPage */ .Py, "_blank");
            setRedirect("/home");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        importAvailable
    ]);
    var mapTypeErrors = [];
    var duplicateRealMapTypes = Array.from(importFilenames.items.values()).filter(function(value, index, self) {
        return self.indexOf(value) !== index && value !== "";
    });
    if (duplicateRealMapTypes.length > 0) {
        mapTypeErrors.push("Duplicate texture types: " + Array.from(new Set(duplicateRealMapTypes.sort())).join(", "));
    }
    var duplicatePseudoMapTypes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = importFilenames.items.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (_utils_shared_formatLib__WEBPACK_IMPORTED_MODULE_18__/* .PseudoTextureTypes.has */ .b5.has(value) && Array.from(importFilenames.items.values()).includes(_utils_shared_formatLib__WEBPACK_IMPORTED_MODULE_18__/* .PseudoTextureTypes.get */ .b5.get(value))) {
                duplicatePseudoMapTypes.push(value);
                duplicatePseudoMapTypes.push(_utils_shared_formatLib__WEBPACK_IMPORTED_MODULE_18__/* .PseudoTextureTypes.get */ .b5.get(value));
                var errorMessage = "Conflicting texture types: ".concat(value, " and ").concat(_utils_shared_formatLib__WEBPACK_IMPORTED_MODULE_18__/* .PseudoTextureTypes.get */ .b5.get(value));
                if (!mapTypeErrors.includes(errorMessage)) {
                    mapTypeErrors.push(errorMessage);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var duplicateMapTypes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(duplicateRealMapTypes).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(duplicatePseudoMapTypes))));
    if (!Array.from(importFilenames.items.values()).every(function(value) {
        return Boolean(value);
    })) {
        mapTypeErrors.push("All filenames need a texture type (set to basecolor if unsure)");
    }
    function onTagsChanged(materialId, tagsChanged) {
        return _onTagsChanged.apply(this, arguments);
    }
    function _onTagsChanged() {
        _onTagsChanged = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function(materialId, tagsChanged) {
            var selected, _secondary;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                selected = tagsChanged.selected, _secondary = tagsChanged._secondary;
                setTagList((0,_utils_materialsLib__WEBPACK_IMPORTED_MODULE_9__/* .collectTags */ .OI)(null, false, selected));
                return [
                    2
                ];
            });
        });
        return _onTagsChanged.apply(this, arguments);
    }
    function submitUppy() {
        return _submitUppy.apply(this, arguments);
    }
    function _submitUppy() {
        _submitUppy = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
            var success, types, scanConfig, scan, createResult, e, materialUserPath, processResult, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        success = false;
                        types = photos.map(function(photo, index) {
                            var originalFilename = originalPhotos[index].name;
                            var textureType = importFilenames.items.get(originalFilename);
                            return textureType;
                        });
                        scanConfig = {
                            types: types
                        };
                        scan = {
                            photos: photos,
                            originalPhotos: originalPhotos,
                            name: name,
                            text: text,
                            sku: sku,
                            scanConfig: scanConfig,
                            skipTiling: skipTiling
                        };
                        if (tagList) {
                            scan["tags"] = tagNamesFromList(tagList);
                        }
                        createResult = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            createScan(galleryUser, materialId, scan)
                        ];
                    case 2:
                        createResult = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,_utils_errorLib__WEBPACK_IMPORTED_MODULE_8__/* .onError */ .q)(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (!(createResult.status === "success")) return [
                            3,
                            9
                        ];
                        materialUserPath = createResult.data.materialUserPath;
                        processResult = {};
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            processScan(galleryUser, materialId, materialUserPath)
                        ];
                    case 6:
                        processResult = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e1 = _state.sent();
                        (0,_utils_errorLib__WEBPACK_IMPORTED_MODULE_8__/* .onError */ .q)(e1);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        success = processResult.status === "success";
                        _state.label = 9;
                    case 9:
                        return [
                            2,
                            success
                        ];
                }
            });
        });
        return _submitUppy.apply(this, arguments);
    }
    function submitUploadLink() {
        return _submitUploadLink.apply(this, arguments);
    }
    function _submitUploadLink() {
        _submitUploadLink = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
            var success, data, response, ref, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        success = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            apiPost("/batch/upload", {
                                userId: galleryUserItem.userId,
                                sourceUrl: uploadLinks[uploadMethod],
                                tags: tagNamesFromList(tagList),
                                process: true,
                                scanType: scanType,
                                skipTiling: skipTiling
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        success = (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.status) === "success";
                        data = response === null || response === void 0 ? void 0 : response.data;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0,_utils_errorLib__WEBPACK_IMPORTED_MODULE_8__/* .onError */ .q)(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2,
                            [
                                success,
                                data
                            ]
                        ];
                }
            });
        });
        return _submitUploadLink.apply(this, arguments);
    }
    function submit(event) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function(event) {
            var uploadSuccess, uploadData, ref, reason, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        mixpanel_browser__WEBPACK_IMPORTED_MODULE_5__/* ["default"].track */ .Z.track("Import Texture", {
                            "Material Name": name,
                            "Description": text,
                            "SKU": sku,
                            "Texture Count": importFilenames.items.size,
                            "Upload Link": uploadLinks[uploadMethod],
                            "Screen": "Import",
                            "Method": _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethodNames */ .W4[uploadMethod]
                        });
                        uploadSuccess = false;
                        setNavWarning(false);
                        setLoading(true);
                        if (!(uploadMethod === _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            submitUppy()
                        ];
                    case 1:
                        uploadSuccess = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (![
                            _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.WE_TRANSFER */ .gc.WE_TRANSFER,
                            _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.S3 */ .gc.S3
                        ].includes(uploadMethod)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            submitUploadLink()
                        ];
                    case 3:
                        ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), uploadSuccess = ref[0], uploadData = ref[1], ref;
                        _state.label = 4;
                    case 4:
                        setLoading(false);
                        if (uploadSuccess) {
                            setProcessSuccess(true);
                            showAlert({
                                status: "success",
                                message: "Texture processing launched"
                            });
                        } else {
                            setProcessFail(true);
                            reason = "";
                            if (uploadData && "sourceUrl" in (uploadData === null || uploadData === void 0 ? void 0 : uploadData.data)) {
                                ;
                                reason = ": ".concat(uploadData === null || uploadData === void 0 ? void 0 : (ref1 = uploadData.data) === null || ref1 === void 0 ? void 0 : ref1.sourceUrl);
                            }
                            showAlert({
                                status: "error",
                                message: "Error launching texture processing".concat(reason)
                            });
                        }
                        setRedirect("/status");
                        return [
                            2
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function createScan(userId, materialId, scan) {
        return _createScan.apply(this, arguments);
    }
    function _createScan() {
        _createScan = // Create a new scan material in the database
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function(userId, materialId, scan) {
            var response;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apiPost("/materials", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({
                                userId: userId,
                                materialId: materialId,
                                scanType: scanType,
                                originMethod: "upload"
                            }, scan))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.data
                        ];
                }
            });
        });
        return _createScan.apply(this, arguments);
    }
    function processScan(userId, materialId, materialUserPath) {
        return _processScan.apply(this, arguments);
    }
    function _processScan() {
        _processScan = // Start processing a scan
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function(userId, materialId, materialUserPath) {
            var response;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Exception handling is performed by the caller
                        console.log("Processing materialId ".concat(materialId, " for userId ").concat(userId, " using materialUserPath ").concat(materialUserPath));
                        return [
                            4,
                            apiPost("/process", {
                                materialUserPath: materialUserPath,
                                action: "texin",
                                target: [
                                    "shimmer",
                                    "textures",
                                    "tiled"
                                ]
                            }, {
                                params: {
                                    userId: userId,
                                    materialId: materialId
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.data
                        ];
                }
            });
        });
        return _processScan.apply(this, arguments);
    }
    if (!isAuthenticated || !galleryUser) {
        return null;
    }
    if (redirect) {
        router.push(redirect);
    }
    var allowImport = importAvailable || qaDisplay;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Bandicoot - App - Import"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_GalleryTabSelector__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                current: "import"
            }),
            !allowImport && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                        children: "Be one of the first to experience the tiling revolution of effortless PBR tiling."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: _utils_shared_business__WEBPACK_IMPORTED_MODULE_17__/* .importLandingPage */ .Py,
                            target: "_blank",
                            children: "Sign up here"
                        })
                    })
                ]
            }),
            allowImport && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                    maxWidth: "100em",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                            container: true,
                            alignContent: "flex-start",
                            alignItems: "flex-start",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                        children: "Upload your PBR texture to create a seamlessly tiled 3D-ready digital material."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        className: classes.guideButton,
                                        color: "primary",
                                        onClick: function() {
                                            return window.open(_utils_linksLib__WEBPACK_IMPORTED_MODULE_32__/* .importGuideUrl */ .lw, "_blank");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_MenuBookSharp__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                                                className: classes.guideIcon
                                            }),
                                            "Import guide"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            className: classes.form,
                            onSubmit: submit,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                    container: true,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                            item: true,
                                            xs: 9,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                                                variant: "filled",
                                                fullWidth: true,
                                                margin: "normal",
                                                label: "Material name",
                                                onChange: function(e) {
                                                    return setName(e.target.value);
                                                },
                                                value: uploadMethod === _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY ? name : "(the texture folder names will be used as the material names)",
                                                required: uploadMethod === _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY,
                                                disabled: uploadMethod !== _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY,
                                                size: "small"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                            item: true,
                                            xs: 3,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                                                variant: "filled",
                                                fullWidth: true,
                                                margin: "normal",
                                                label: "SKU",
                                                onChange: function(e) {
                                                    return setSku(e.target.value);
                                                },
                                                value: uploadMethod === _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY ? sku : "(set the SKUs after processing)",
                                                disabled: uploadMethod !== _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY,
                                                size: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                    container: true,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                            item: true,
                                            xs: 9,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                                                variant: "filled",
                                                fullWidth: true,
                                                margin: "normal",
                                                label: "Description",
                                                onChange: function(e) {
                                                    return setText(e.target.value);
                                                },
                                                value: uploadMethod === _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY ? text : "(set the descriptions after processing)",
                                                disabled: uploadMethod !== _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY,
                                                size: "small"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                            item: true,
                                            xs: 3,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                                container: true,
                                                className: classes.tagsContainer,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                                        item: true,
                                                        xs: 2,
                                                        className: classes.tagsText,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .ZP, {
                                                            title: tagsHelpText,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                                variant: "body1",
                                                                children: "Tags"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                                        item: true,
                                                        xs: 10,
                                                        className: classes.tags,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TagList__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                            materialId: materialId,
                                                            tags: tagList,
                                                            onChange: onTagsChanged,
                                                            tagChoices: userTags,
                                                            alwaysExpanded: true
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Accordions__WEBPACK_IMPORTED_MODULE_12__/* .StyledAccordion */ .s, {
                                    className: classes.accordion,
                                    expanded: advancedProcessingExpanded,
                                    onChange: updateAdvancedProcessing,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Accordions__WEBPACK_IMPORTED_MODULE_12__/* .StyledAccordionSummary */ .k, {
                                            expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {}),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                variant: "caption",
                                                children: "Advanced settings"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                                container: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: classes.checkboxContainer,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
                                                                color: "primary",
                                                                checked: skipTiling,
                                                                onChange: function() {
                                                                    return setSkipTiling(!skipTiling);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                                display: "inline",
                                                                onClick: function() {
                                                                    return setSkipTiling(!skipTiling);
                                                                },
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                children: "Disable tiling"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .ZP, {
                                                                title: "When tiling is disabled, the tiling process will be skipped. " + "This is useful when the texture is already seamlessly tiled or tiling is not desired, " + "for example when importing texture for stitching.",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_InfoOutlined__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z, {
                                                                    className: classes.helpIcon,
                                                                    fontSize: "small",
                                                                    color: "secondary"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                        scanType: scanType,
                                        userId: galleryUser,
                                        userItem: galleryUserItem,
                                        name: name,
                                        setName: setName,
                                        setPhotos: setPhotos,
                                        originalPhotos: originalPhotos,
                                        setOriginalPhotos: setOriginalPhotos,
                                        importFilenames: importFilenames,
                                        setImportFilenames: setImportFilenames,
                                        updateImportFilenames: updateImportFilenames,
                                        setUploadComplete: setUploadComplete,
                                        duplicateMapTypes: duplicateMapTypes,
                                        mapTypeErrors: mapTypeErrors,
                                        materialId: materialId,
                                        setMaterialId: setMaterialId,
                                        onUploading: setNavWarning,
                                        uploadMethod: uploadMethod,
                                        setUploadMethod: setUploadMethod,
                                        uploadLinks: uploadLinks,
                                        setUploadLinks: setUploadLinks
                                    }, scanType)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProgressButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        size: "large",
                                        type: "submit",
                                        disabled: !validateForm(),
                                        loading: loading,
                                        success: processSuccess,
                                        tooltip: validateForm() ? "Click to begin import" : "Please drag your texture images in and ensure each is assigned a unique texture type",
                                        children: uploadMethod === _components_PhotoUpload__WEBPACK_IMPORTED_MODULE_14__/* .UploadMethod.UPPY */ .gc.UPPY ? "Import material" : "Import materials"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = ((0,_auth0_auth0_react__WEBPACK_IMPORTED_MODULE_4__/* .withAuthenticationRequired */ .u3)(Import, {
    onBeforeAuthentication: function() {
        (0,_utils_authLib__WEBPACK_IMPORTED_MODULE_6__/* .logAuthenticationRequired */ .R)("Import");
    }
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [99,524,940,221,993,244,774,888,179], function() { return __webpack_exec__(61622); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);